import React, { useRef, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import { useLocation } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { routeNames } from '../../../util/Constants';

import FilterLabel from '../FilterLabel';
import DeliveryDetail from '../DeliveryDetails';

import TakeoutOrDeliverySelector from '../../input/TakeoutOrDeliverySelector/TakeoutOrDeliverySelector';

const typeAvailableInSet = [
  routeNames.menu,
  routeNames.restaurantMenu,
  routeNames.restaurantOrder,
  routeNames.restaurants,
];

function FilterMobile() {
  const location = useLocation();
  const typeSelectorAvailable = useMemo(
    () =>
      typeAvailableInSet.includes(location.pathname) ||
      location.pathname.includes('/restaurant/'),
    [location]
  );

  const { userAddress, date, time, delays } = useSelector(
    ({ main, restaurant, address: selectedAddress, time: selectedTime }) => ({
      isAddressOpen: main.isAddressOpen,
      isEditTimeOpen: main.isEditTimeOpen,
      userAddress: selectedAddress.selectedAddress,
      date: selectedTime.selectedDate,
      time: selectedTime.selectedTime,
      delays: restaurant?.selectedRestaurantMenu?.delays,
    })
  );
  const [showDeliveryDetails, setDeliveryDetails] = useState(false);
  const DeliveryDetailsRef = useRef(null);

  return (
    <Stack
      direction="row"
      sx={{
        borderBottom: '1px solid lightgrey',
        p: 1,
      }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Button
        data-test-id="set-delivery-button"
        onClick={() => setDeliveryDetails(!showDeliveryDetails)}
      >
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={0}
        >
          <Typography variant="body2" sx={{ ml: 0.5 }} color="text.secondary">
            <FilterLabel time={time} date={date} delays={delays} />
          </Typography>
          <Stack direction="row" justifyContent="center" alignItems="center">
            <LocationOnIcon fontSize="small" />
            <Typography component="span" sx={{ mx: 0.5 }}>
              {userAddress?.address || 'No address'}
            </Typography>
            <KeyboardArrowDownIcon fontSize="small" />
          </Stack>
        </Stack>
        <DeliveryDetail
          open={showDeliveryDetails}
          anchorEl={DeliveryDetailsRef?.current}
          onClose={() => setDeliveryDetails(false)}
        />
      </Button>
      <Box sx={{ width: '130px' }}>
        {typeSelectorAvailable && (
          <TakeoutOrDeliverySelector typeVersion="Select" />
        )}
      </Box>
    </Stack>
  );
}

export default FilterMobile;
